import type { HelpPortalSource } from "@/lib/help-portal";
import {
  INSPECTION_HELP_ARTICLES,
  INSPECTION_HELP_CATEGORIES,
  inspectionArticlesInCategory,
} from "@/lib/inspection-help/articles";
import { searchInspectionHelpArticles } from "@/lib/inspection-help/search";

export {
  INSPECTION_HELP_ARTICLES,
  INSPECTION_HELP_ARTICLE_IDS,
  INSPECTION_HELP_CATEGORIES,
  getInspectionHelpArticle,
  isInspectionHelpArticleId,
  inspectionArticlesInCategory,
} from "@/lib/inspection-help/articles";
export { searchInspectionHelpArticles } from "@/lib/inspection-help/search";
export type { InspectionHelpArticleId } from "@/lib/inspection-help/articles";

export const INSPECTION_HELP_PORTAL: HelpPortalSource = {
  articles: INSPECTION_HELP_ARTICLES,
  categories: INSPECTION_HELP_CATEGORIES,
  searchArticles: searchInspectionHelpArticles,
  articlesInCategory: inspectionArticlesInCategory,
  indexTo: "/inspection/help",
  articleTo: "/inspection/help/$articleId",
  emptySearchHint:
    "Try a different word, such as queue, perform, photos, or documents.",
};
